var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c(
        "g-pesquisa",
        {
          ref: "refPesquisa",
          attrs: {
            filtroAdicional: _vm.getFiltroPesquisa,
            limparFiltroLocal: _vm.limparFiltro,
            colunasPropriedade: _vm.colunas,
            apiPesquisa: _vm.apiAssunto,
            operacoes: _vm.operacoes,
            exibirColunaOperacoes: _vm.exibirColunaOperacoes,
            elementosPorPagina: _vm.elementosPorPagina,
            novo: _vm.cadastrarItem,
            imprimir: _vm.imprimir,
            showTermoPesquisa: false,
            showBuscaAvancadaAberta: true,
            carregamentoInicial: false,
            showBotaoNovo: _vm.permissaoPerfil.incluir
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12" },
              [
                _c("g-input", {
                  ref: "refDescricao",
                  attrs: {
                    id: "refDescricao",
                    name: "refDescricao",
                    tipo: "text",
                    etiqueta: "Descrição",
                    foco: false,
                    tamanho: 100,
                    chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                  },
                  model: {
                    value: _vm.assunto.desAssunto,
                    callback: function($$v) {
                      _vm.$set(_vm.assunto, "desAssunto", $$v)
                    },
                    expression: "assunto.desAssunto"
                  }
                })
              ],
              1
            )
          ]),
          _c("br")
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }